var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.89397,
    x2: 0.49996,
    y1: 0.07228,
    x1: 0.49996,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE5D2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EC8",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.93142,
    x2: 0.98403,
    y1: 0.19668,
    x1: 0.20306,
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9D29",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E41689",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.83915,
    x2: 0.33434,
    y1: 0.19612,
    x1: 0.72689,
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9D29",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E41689",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_2",
    fill: "url(#SVGID_1_)",
    points: "181.09591849102435,169.450539090416 181.09591849102435,510.61495978602034 36.57002085871318,427.1597039022017 36.57002085871318,252.77304014789843 ",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_3",
    fill: "url(#SVGID_2_)",
    d: "m455.19531,185.46474l-123.15892,71.11277l-150.94046,-87.14909l-144.52593,-83.43309l144.52593,-83.45521l208.60484,120.43828c0,0 0.39814,0.24331 1.17231,0.66357l1.63681,0.95112c0.33179,0.19907 0.66357,0.37602 1.0396,0.61933c8.78127,5.2201 30.56854,19.1551 44.99017,36.31949c0.30967,0.37602 0.61933,0.72993 0.90688,1.10595c0.37602,0.48662 0.79629,0.99536 1.17231,1.5041c0.48662,0.59721 0.97324,1.19443 1.41562,1.81376c4.37957,5.75096 8.89186,12.27608 13.16084,19.50901z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_4",
    fill: "url(#SVGID_3_)",
    d: "m455.81465,328.06632c-10.35172,16.92108 -24.0213,31.89568 -39.54888,44.08328c-5.90579,4.645 -12.07701,8.95822 -18.38094,13.05024c-23.29137,15.10732 -48.46286,27.14009 -72.01966,41.84926c-47.79929,-27.51611 -95.62069,-55.0101 -143.41998,-82.52621c-0.44238,-0.26543 -0.90688,-0.53086 -1.34926,-0.77417l150.94046,-87.14909c0,0 123.15892,-71.11277 123.15892,-71.11277c2.05707,-1.19443 16.30175,37.35909 17.16439,40.76543c4.22474,16.52294 5.26434,33.7758 2.63217,50.65264c-2.83124,18.2261 -9.59967,35.52321 -19.17722,51.16138z",
    className: "st2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4467415813b59937dcf195ca4da12e30.svg";
export { ForwardRef as ReactComponent };